<template>
  <div>
    <div class="row mt-50">
      <div class="col-md-8 col-md-offset-2">
        <div class="card general-active-section" id="wizardCard">
          <form-wizard ref="wizard"
                       shape="tab"
                       :error-color="primary"
                       :title="title"
                       :subtitle="computeCaption(fields_en['patient_registration_form'], $store.state.lang.value.toLowerCase())"
                       :color='primary'>

            <tab-content :title="computeCaption(fields_en['payment'], $store.state.lang.value.toLowerCase())"
                         icon="ti-credit-card">
              <first-step v-if="publicKey" ref="firstStep" :section="false">
              </first-step>
              <first-step-auth v-if="publicKey === ''" ref="firstStep" :section="false">
              </first-step-auth>
            </tab-content>
          <button slot="finish" class="display-none"><span>  Pay Now and Submit </span></button>
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import variables from '../../../../assets/sass/paper/_variables.scss'
  import FirstStep from '../Utils/SubComponents/PaymentParts/paymentOrderStripe.vue'
  import FirstStepAuth from '../Utils/SubComponents/PaymentParts/paymentOrderAuthorize.vue'
  import {TranslationsUtils} from '../../../../utils/Translations'
  export default {
    data () {
      return {
        publicKey: this.$store.state.configs.STRIPE_PUBLIC_KEY || '',
        primary: variables.primaryColor,
        secondary: variables.secondaryColor,
        fields_en: {
          i_agree_and_submit: 'Submit',
          patient_registration_form: 'Payment',
          payment: 'Payment'
        },
        disabled: false,
        title: this.$store.state.configs.LAB_NAME,
        wizardModel: {}
      }
    },
    components: {
      FirstStep,
      FirstStepAuth
    },
    mixins: [TranslationsUtils],
    mounted: function () {
      this.$sidebar.isMinimized = true
    },
    async beforeMount () {
      if (this.$route.query.lang !== undefined) {
        this.$store.state.lang.value = this.$route.query.lang
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../../../assets/sass/paper/_variables.scss';

  .vue-form-wizard .wizard-nav-pills>li>a {
    color: $primary-color;
  }

  .vue-form-wizard .wizard-nav-pills>li>a.disabled {
    color: $secondary-color;
  }

  .vue-form-wizard .wizard-icon-circle {
    background-color: white;
    color: $secondary-color !important;
    border: 3px solid $secondary-color !important;
  }

  .checked {
    color: white !important;
    background-color: $primary-color !important;
  }

  .display-none{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Patient/PaymentWizard.vue